import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionsListView';
import { AppState } from '../../../../../types/store';
import {
  setCurrentlyViewedFolderId,
  addFolderToFullViewList,
} from '../../../../actions/gallectionSection';
import {
  getCurrentlyViewedFolder,
  getNextFullViewFolderId,
} from '../../../../selectors/gallectionSection';

export type StateProps = Pick<Props, 'currentFolder' | 'nextFullViewFolderId'>;
export type DispatchProps = Pick<
  Props,
  'setCurrentlyViewedFolderId' | 'addFolderToFullViewList'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  return {
    currentFolder: getCurrentlyViewedFolder(state),
    nextFullViewFolderId: getNextFullViewFolderId(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setCurrentlyViewedFolderId,
  addFolderToFullViewList,
};

export default connect(mapStateToProps, mapDispatchToProps);
